/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Iscanceled1Inputs */

const en__field_iscanceled1 = /** @type {(inputs: _Field_Iscanceled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

const de__field_iscanceled1 = /** @type {(inputs: _Field_Iscanceled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgebrochen`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {_Field_Iscanceled1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_iscanceled1 = /** @type {((inputs?: _Field_Iscanceled1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Iscanceled1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_iscanceled1(inputs)
	return de__field_iscanceled1(inputs)
});
export { _field_iscanceled1 as "_field_isCanceled" }